import { createFileRoute, redirect } from "@tanstack/react-router";

// 301-style redirect: /wdec → /gestao-de-atendimento
export const Route = createFileRoute("/wdec")({
  beforeLoad: () => {
    throw redirect({ to: "/gestao-de-atendimento", replace: true });
  },
  component: () => null,
});
